export default class Validator {
  static isValidUsername(username, newRegistrationFlag) {
    const regexp = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,16})+$/);
    const oldUsernameRegex = new RegExp(/^[a-zA-Z\d][^%*";\\%+$/\s]{2,63}$/);
    return (
      regexp.test(username) ||
      (!newRegistrationFlag && oldUsernameRegex.test(username))
    );
  }
  static formatUsernameForDisplay(username) {
    if (!Validator.isValidUsername(username)) {
      return username;
    }

    if (username.slice(0, 2) === "27") {
      username = "0" + username.slice(2);
    }

    return username;
  }

  static isValidEmail(email) {
    const regexp = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return regexp.test(email);
  }

  static isValidCellphone(cellphone) {
    const regexp = /^(0|27)((?=\d*$)(?:.{9}|.{13}))$/g;
    return regexp.test(cellphone);
  }

  static formatMsisdnForDisplay(cellphone) {
    if (!Validator.isValidCellphone(cellphone)) {
      return cellphone;
    }

    if (cellphone.slice(0, 2) === "27") {
      cellphone = "0" + cellphone.slice(2);
    }

    return cellphone;
  }

  static isValidPassword(password) {
    const regexp = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/);
    return regexp.test(password);
  }

  static isValidOtp(otp) {
    const regexp = new RegExp(/^\d{6}$/);
    return regexp.test(otp);
  }
  static isValidFirstName(firstName) {
    const regexp = new RegExp(/^[a-zA-Z][a-zA-Z0-9_\s-]+$/);
    return regexp.test(firstName);
  }
}
